export default __webpack_public_path__ + "97667d8cd09ef6acdf714745d4d8f6a4.woff";